module.exports = __webpack_public_path__ + "img/listen-on-spotify.382f4269.svg";